<template>
    <div id="bene-email-container">
        <f7-list form class="form-group">
            <f7-list-input
                input-id     ="email"
                name         ="email"
                type         ="email"

                v-if         ="showFormInput.contact.email"
                :label       ="emailLabel"
                :placeholder ="emailLabel"
                :value       ="email"
                @change      ="setEmail($event.target.value); validateInput($event.target); setInput($event.target)"

                autocomplete ="off"
                outline
                floating-label
                clear-button
            ></f7-list-input>
        </f7-list>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    export default {
        props: {
        },
        mounted() {
        },
        data: function() {
            return {}
        },
        computed: {
            ...mapGetters('beneficiary', [
                'showFormSet',
                'showFormInput',
                'email',
                'emailLabel',
            ])
        },
        methods: {
            ...mapActions('beneficiary', [
                'setEmail',
            ]),

            validateInput(inputEl){
                this.$emit("validateInput", inputEl);
            },

            setInput(inputEl){
                this.$emit("setInput", inputEl);
            }
        }
    }
</script>